import React from 'react';
import { v4 as uuidv4 } from 'uuid';
import './RiskScale.css';

type RiskScaleProps = {
    scales: {text: string}[],
    activeIndex?: number,
};

const RiskScale = ({
    scales = [
        { text: 'lower' },
        { text: 'low' },
        { text: 'middle' },
        { text: 'higher' },
        { text: 'high' },
    ],
    activeIndex = undefined,
} : RiskScaleProps) => (
    <div className="RiskScale">
        {
            scales?.map(({ text }, index) => {
                const uuid = uuidv4(text);

                return (
                    <div className="RiskScale__Item" key={uuid}>
                        <div>
                            {(index === 0 || index === 2 || index === 4) && <p className="RiskScale__Item__Text">{text}</p>}
                        </div>
                        <div className={`rect rect-${index}${activeIndex === index ? ' active' : ''}`}/>
                    </div>
                );
            })
        }
    </div>
);

export default RiskScale;
